import { Images } from "Components/Images";
import { TagBadge } from "Components/TagBadge";
import { STAR } from "Constants/Common";
import IStyle from "Interfaces/IStyle";
import Student from "Models/Student";
import StudentMap from "Models/StudentMap";
import { isAprilFools } from "Utils/Common";
import React, { CSSProperties } from "react";
import { Card, Figure } from "react-bootstrap";
import { Link } from "react-router-dom";
const styles:IStyle = {
	imgCompact2: {
		clipPath: "inset(20% 0% 35% 0% round 0.3em 0.3em 0 0)",
		padding: 0,
		margin: "-23% 0% -39% 0%",
	},
	imgCompact: {
		clipPath: "inset(32% 0% 40% 0% round 0.3em 0.3em 0 0)",
		padding: 0,
		margin: "-35% 0% -43% 0%",
	},
	imgCompactOg: {
		clipPath: "inset(20% 20% 30% 20% round 0.5em)",
		padding: 0,
		margin: "-20% 0 -30% 0",
	},
	left: {paddingRight: "0.2em"},
	right: {paddingLeft: "0.2em"},
	noPadding: {
		padding: 0,
		margin: 0
	},
	assistBlock: {
		width: "100%",
		opacity: 0.8,
		padding: 2
	},
	footerOverlay: {
		width: "100%", 
		bottom:0, 
		// zIndex: 2,
		position: "absolute"
	},
	link: {
		zIndex: 1
	},
	compactCard: {
		height:"auto", 
		whiteSpace: "nowrap",
	},
	studentCard: {
		height:"auto", 
		minWidth: 70,
	},
	glow: {
		boxShadow: "0 0 1em #ffafff",
	}
}
interface IProps {
	model:Student, 
	bare?:boolean, 
	alwaysFooter?: boolean, 
	compact?: boolean | number,
	link?: string,
	attrs?: any;
	nameplate?: string;
	disableSchale?: boolean
}

function compactImageStyle(type?: number | boolean): CSSProperties {
	let compactStyle = styles.imgCompact;
	if (typeof(type) === "number") {
		switch (type) {
			case 2: compactStyle = styles.imgCompact2; break;
		}
	}

	if (!isAprilFools()) {
		return compactStyle;
	}

	const [top, _left, bottom, _right] = compactStyle.clipPath.match(/\d+%/g).map(a=>parseInt(a))
	const [mtop, _mleft, mbottom, _mright] = compactStyle.margin.toString().match(/\d+%/g).map(a=>parseInt(a))
	const diffTop = top - mtop;
	const diffBot = bottom - mbottom;
	const size = 100 - (bottom + top);
	const maxPossible = 100+diffBot-size;
	const rng = Math.floor(Math.random()*maxPossible)
	// 100-(size+rng-diffBot) >= 0
	// 100 >= size+rng-diffBot
	// 100+diffBot-size >= rng

	return {
		...compactStyle,
		// position: "relative",
		// top: `${rng}%`,
		// transform: `translate(0, ${rng}%)`,
		// transformOrigin: `50% ${rng}% 0`
		clipPath: `inset(${rng}% 0% ${100-(size+rng)}% 0% round 0.3em 0.3em 0 0)`,
		margin: `-${rng-diffTop}% 0% -${100-(size+rng+diffBot)}% 0%`,
	};
}


export default function StudentRenderer(props: IProps) {
	const {model, compact} = props;
	const nameplate = props.nameplate ?? "bg-violet-transparent-70";
	const href = props.link ? props.link.replaceAll("%id%", model.getId().toString()) : undefined;
	const schale = new StudentMap().getSchale(model.getName());
	function AssistBlock({isAssist}:{isAssist?: boolean}) {
		isAssist = typeof(isAssist) === "undefined" ? model.isAssist : isAssist; 
		if (!isAssist) return null;
		if (props.bare) return null;
		return (<Card.Header 
			className="text-center text-pink d-none d-sm-block bg-black"
			style={styles.assistBlock}
			>
			Assist
		</Card.Header>);
	}

	function TextLink({children, to}: {children: any, to?: string}) {
		if (!!!to) return children;

		return (
			<Link style={styles.link} className="text-white" target="_blank" to={to}>{children}</Link>
		)
	}

	function SchaleLink() {
		if (!!props.disableSchale) return null;
		return (
			<Link target="_blank" to={schale} style={{position: "absolute", right: 0}}>
				<Figure.Image
				className="bg-pink-border d-none d-lg-block"
					style={{width: "auto", height: "1.3em"}}
					src="https://www.google.com/s2/favicons?sz=128&domain=schaledb.com"
					>
				</Figure.Image>
			</Link>);
	}
	
	function CompactStudentRenderer() {
		function UE() {
			if (props.bare) return null;
			if (!model.isUe) return <small style={styles.left}>
				{model.getTier()}
			</small>;
			if (model.ue > 0) {
				return (
					<span className="ue-icon" style={styles.left}>
						{model.ue}<span className="star">{STAR}</span>
					</span>
				);	
			}
			return (
				<span className="ue-icon" style={styles.left}>
					<Images.UE />
				</span>
			);
		}
		function Assist() {
			if (!model.isAssist) return null;
			if (props.bare) return null;
			return (
				<sup className="assist-icon d-none d-lg-inline" style={styles.right}>
					<TagBadge>A</TagBadge>
				</sup>
			)
		}

		
		const compactStyle = compactImageStyle(compact);
		return (
			<TextLink to={href}><Card className={`student ${model.isAssist?"assist":"own"}`} {...props.attrs} style={{...styles.compactCard, ...(model.isSkillSelected ? styles.glow : null)}}>
				<Card.Img className="display" variant="top" style={compactStyle} src={model.getIcon()} />
				<Card.Body style={styles.noPadding}>
				</Card.Body>
				<Card.Footer style={{padding:0.2}}
					className={`text-center text-white nameplate ${nameplate}`}
				>
					<UE />
					{model.getDisplayName()}
					<Assist />
					<SchaleLink />
				</Card.Footer>
			</Card></TextLink>
		);
	}

	function Badges() {
		if (!!props.bare) return null;
		if (model.isUe && model.ue > 0) {
			return (
				<Card.Text>
					<TagBadge pretext={model.getUeTier()}>UE</TagBadge> <TagBadge pill>{model.getLevel()}</TagBadge>
				</Card.Text>
				);
		}
		return (
		<Card.Text>
			<TagBadge>{model.getTier()}</TagBadge> <TagBadge pill>{model.getLevel()}</TagBadge>
		</Card.Text>
		);
	}
	function FooterOverlay() {
		if (!!props.alwaysFooter) return null;
		return (
		<Card.Footer 
		className={`nameplate text-center d-none d-lg-block text-white ${nameplate}`}
		style={styles.footerOverlay}
		>
			<TextLink to={href}>{model.getDisplayName()}</TextLink>
			<SchaleLink />
		</Card.Footer>
		);
	}
	
	if (compact) return <CompactStudentRenderer />;
	
	return (
		<TextLink to={href}><Card className={`student ${model.isAssist?"assist":"own"}`} {...props.attrs} style={{...styles.studentCard, ...(model.isSkillSelected ? styles.glow : null)}}>
			<Card.Img className="display" {...props.attrs} variant="top" src={model.getIcon()} />
			<Card.ImgOverlay style={{...styles.noPadding,...styles.top}}>
				
				<AssistBlock {...props} isAssist={!!!props.bare && model.isAssist} />
				<Card.Body style={styles.noPadding}>
					<Badges />
					<FooterOverlay />
				</Card.Body>
			</Card.ImgOverlay>
			<Card.Footer
			style={{padding:2}}
			className={props.alwaysFooter ? `text-center nameplate ${nameplate} text-white` : `nameplate ${nameplate} text-white text-center d-block d-lg-none`}
			>
				<TextLink to={href}>{model.getDisplayName()}</TextLink>
				<SchaleLink />
			</Card.Footer>
		</Card></TextLink>
	);
}